import React from 'react'
import { useLocation } from 'react-router-dom'
import { LayoutDashboard, Users, UsersRound, Mail, Building2, Route } from 'lucide-react'
import { NavigationMenu } from '@/components/play'
import { useAuth } from '@/state/AuthContext'
import { getAdminNavItems, type AdminNavItemKey } from '@/lib/adminCapabilities'

const icons: Record<AdminNavItemKey, typeof LayoutDashboard> = {
  account: Building2,
  infrastructure: LayoutDashboard,
  organizations: Building2,
  users: Users,
  teams: UsersRound,
  srt_bridges: Route,
  private_beta: Mail,
}

/** The Admin pages' frame: the Play app page with the sections above it as one Play navigation row, each with its icon
 *  and the current one filled. Where the row runs out of room, as on a phone, it scrolls sideways and brings the
 *  current section into view (NavigationMenu's `scrollable`), so the page starts near the top. */
export function AdminLayout({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation()
  const { user } = useAuth()
  const links = getAdminNavItems(user?.attributes?.role).map((item) => {
    const Icon = icons[item.key]
    const current = item.href === '/admin' ? pathname === '/admin' : pathname === item.href || pathname.startsWith(`${item.href}/`)
    return { to: item.href, label: item.label, icon: <Icon />, current }
  })

  return (
    <div className="app-page max-w-7xl">
      <div className="flex flex-col gap-6">
        {links.length > 0 && <NavigationMenu label="Admin" items={links} scrollable />}
        <div className="min-w-0">{children}</div>
      </div>
    </div>
  )
}
